export default __webpack_public_path__ + "static/media/logo-alvarez-marsal.d7402278.svg";